module.exports = __webpack_public_path__ + "static/histogram-with-specified-bins-13d55764fa5d3bf451823a7bb5d9582e.png";